import React from 'react';
import { SummaryFormItem } from './SummaryFormItem';
import { BillingCycleType } from './types';
import { planPrice } from './utils';

type PlanItemProps = {
  name: React.ReactNode;
  price: number;
  cycle: BillingCycleType;
  hint?: string;
};

export const PlanItem = ({ name, price, cycle, hint }: PlanItemProps) => (
  <SummaryFormItem label={name} price={planPrice(price, cycle)} hint={hint} />
);
